<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">{{
        JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).name
      }}</span>
    </div>
    <el-main>
      <el-descriptions
        class="margin-top"
        style="width: 100%"
        :column="4"
        border
      >
        <el-descriptions-item>
          <template slot="label"> 分类 </template>
          <el-cascader
            :options="zNodes"
            v-model="treeId"
            style="width: 82%"
            :props="{
              value: 'fctm01',
              label: 'fctm02',
              children: 'children',
              multiple: true,
            }"
            clearable
          ></el-cascader>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 审批状态 </template>
          <el-select v-model="state" placeholder="请选择">
            <el-option
              v-for="item in typeOptions1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 发起人 </template>
          <el-select v-model="userId" placeholder="请选择">
            <el-option
              v-for="item in userList"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 关键词 </template>
          <el-input style="width: 200px" v-model="searchword"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 发起时间 </template>
          <el-date-picker
            v-model="startTime"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 完结时间 </template>
          <el-date-picker
            v-model="endTime"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button type="primary" style="margin-left: 50px" @click="submit"
            >查询</el-button
          >
          <el-button style="margin-left: 50px" @click="reset">重置</el-button>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        height="53vh"
        style="margin-top: 20px"
        align="center"
        class="table"
        :data="dataList"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="fmap03"
          label="模版名称"
        ></el-table-column>
        <el-table-column align="center" label="重要程度">
          <template slot-scope="scope">
            {{ scope.row.fmtp09 == 1 ? "一般" : "重大" }}
          </template></el-table-column
        >
        <el-table-column
          align="center"
          prop="user04"
          label="创建人"
        ></el-table-column>
        <el-table-column align="center" prop="date" label="表单状态">
          <template slot-scope="scope">
            {{
              scope.row.famp11 == "1"
                ? "进行中"
                : scope.row.famp11 == "2"
                ? "已通过"
                : scope.row.famp11 == "3"
                ? "未通过"
                : "已撤回"
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="famp10"
          label="发起时间"
        ></el-table-column>
        <el-table-column align="center" prop="endTime" label="完结时间">
          <template slot-scope="scope">
            {{ scope.row.endTime ? scope.row.endTime : "--" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="showForm(scope.row)"
              size="small"
              type="primary"
              plain
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mar-top20"
        align="right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <data-Search ref="dataSearch"></data-Search>
    </el-main>
  </el-card>
</template>
<script>
import dataSearch from "@/components/dataSearch.vue";
import {
  GetXGFormApply,
  GetFunctionTemplate,
  GetProUsersList,
} from "@/setAxios.js";
export default {
  name: "",
  props: {},
  components: { dataSearch },
  data() {
    return {
      dataList: [],
      userList: [],
      options: [],
      treeId: [],
      key: {},
      typeOptions: [
        {
          value: 1,
          label: "全部",
        },
        {
          value: 2,
          label: "项目建议书",
        },
        {
          value: 3,
          label: "可行性研究报告",
        },
        {
          value: 4,
          label: "项目投资估算",
        },
        {
          value: 5,
          label: "项目地质灾害评估",
        },
      ],
      typeValue: "",
      typeOptions1: [
        {
          value: "null",
          label: "全部",
        },
        {
          value: 1,
          label: "进行中",
        },
        {
          value: 2,
          label: "已通过",
        },
        {
          value: 3,
          label: "未通过",
        },
        {
          value: 4,
          label: "已撤销",
        },
      ],
      state: "null",
      userId: "",
      searchword: "",
      startTime: "",
      endTime: "",
      functionList: [
        {
          date: "111",
        },
      ],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      zNodes: [],
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.GetFunctionTemplate();
        this.GetProUsersList();
        this.dataList = [];
        this.treeId = [];
        this.total = 0;
        this.key = JSON.parse(this.$UrlEncode.decode(this.$route.query.key));
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    GetFunctionTemplate() {
      let _this = this;
      let params = {
        companyId: localStorage.pid,
        xid: localStorage.xid,
      };
      GetFunctionTemplate({ params }).then((res) => {
        if (res.Code) {
          _this.zNodes = _this
            .getTreeDate(res.Data.projectfunctiontemplates, "fctm01", "fctm03")
            .filter((el) => el.fctm01 == _this.key.type);
        }
      });
    },
    GetProUsersList() {
      let params = {
        seachword: "",
        id: localStorage.xid,
        cid: localStorage.pid,
        bid: "null",
        pageIndex: 1,
        pageSize: 999999,
      };
      GetProUsersList({ params }).then((res) => {
        this.userList = res.Data.list;
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    GetXGFormApply() {
      GetXGFormApply({
        params: {
          xid: localStorage.xid,
          uid: this.userId,
          startTime: this.startTime.length ? this.startTime.join() : "",
          endTime: this.endTime.length ? this.endTime.join() : "",
          searchword: this.searchword,
          state: this.state,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          tempIds: this.treeId.map((el) => el.slice(-1).toString()).join(),
        },
      }).then((res) => {
        this.dataList = res.Data.list;
        this.total = res.Data.total;
      });
    },
    submit() {
      if (!this.treeId.length) {
        this.$message.error("请选择分类！");
        return false;
      } else {
        this.GetXGFormApply();
      }
    },
    reset() {
      this.treeId = "";
      this.userId = "";
      this.dataList = [];
      this.startTime = "";
      this.endTime = "";
      this.searchword = "";
    },
    showForm(item) {
      this.$refs.dataSearch.id = item.fmap01;
      this.$refs.dataSearch.open();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetXGFormApply();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetXGFormApply();
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped></style>
